import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Search, MapPin, Phone, Clock, Navigation, PlusSquare, ChevronDown, Share2 } from "lucide-react";
import { Helmet } from "react-helmet-async";
import toast from "react-hot-toast";

export default function Hospitals() {
  const [search, setSearch] = useState("");
  const [typeFilter, setTypeFilter] = useState("All");

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.4, ease: "easeOut" } },
  };

  // 🔥 കല്യാശ്ശേരി മണ്ഡലത്തിലെ സർക്കാർ ആരോഗ്യ കേന്ദ്രങ്ങൾ 🔥
  const hospitalsData = [
    { id: 1, name: "Govt. Medical College Hospital", place: "Pariyaram", type: "Allopathy", phone: "0460-2280000", time: "24/7 Open", map: "https://goo.gl/maps/search/Pariyaram+Medical+College" },
    { id: 2, name: "Govt. Taluk Hospital", place: "Pazhayangadi", type: "Allopathy", phone: "0497-2870100", time: "24/7 Open", map: "https://goo.gl/maps/search/Pazhayangadi+Taluk+Hospital" },
    { id: 3, name: "FHC Kalliassery (കല്ല്യാശ്ശേരി)", place: "Kalliassery", type: "Allopathy", phone: "0497-2783499", time: "9:00 AM - 4:00 PM", map: "#" },
    { id: 4, name: "FHC Kannapuram (കണ്ണപുരം)", place: "Mottammal", type: "Allopathy", phone: "0497-2863468", time: "9:00 AM - 4:00 PM", map: "#" },
    { id: 5, name: "FHC Cherukunnu (ചെറുകുന്ന്)", place: "Cherukunnu", type: "Allopathy", phone: "0497-2864140", time: "9:00 AM - 4:00 PM", map: "#" },
    { id: 6, name: "FHC Mattool (മാട്ടൂൽ)", place: "Mattool South", type: "Allopathy", phone: "0497-2843082", time: "9:00 AM - 4:00 PM", map: "#" },
    { id: 7, name: "FHC Ezhome (ഏഴോം)", place: "Ezhome", type: "Allopathy", phone: "0497-2815163", time: "9:00 AM - 4:00 PM", map: "#" },
    { id: 8, name: "FHC Cheruthazham (ചെറുതാഴം)", place: "Pilathara", type: "Allopathy", phone: "0497-2802686", time: "9:00 AM - 4:00 PM", map: "#" },
    { id: 9, name: "FHC Kunhimangalam (കുഞ്ഞിമംഗലം )", place: "Kandamkulangara", type: "Allopathy", phone: "0497-2812333", time: "9:00 AM - 4:00 PM", map: "#" },
    { id: 10, name: "FHC Kadannappally (കടന്നപ്പള്ളി)", place: "Kandonthar", type: "Allopathy", phone: "0498-5278992", time: "9:00 AM - 4:00 PM", map: "#" },
    { id: 11, name: "FHC Pattuvam (പട്ടുവം)", place: "Pattuvam", type: "Allopathy", phone: "0460-2220990", time: "9:00 AM - 4:00 PM", map: "#" },
    { id: 12, name: "Govt. Ayurveda Hospital", place: "Thavam, Cherukunnu", type: "Ayurveda", phone: "Not Available", time: "9:00 AM - 2:00 PM", map: "#" },
    { id: 13, name: "Govt. Ayurveda Hospital", place: "Mattool South", type: "Ayurveda", phone: "Not Available", time: "9:00 AM - 2:00 PM", map: "#" },
    { id: 14, name: "Govt. Ayurveda Dispensary", place: "Ezhome", type: "Ayurveda", phone: "Not Available", time: "9:00 AM - 2:00 PM", map: "#" },
    { id: 15, name: "Govt. Ayurveda Dispensary", place: "Pattuvam", type: "Ayurveda", phone: "Not Available", time: "9:00 AM - 2:00 PM", map: "#" },
    { id: 16, name: "Govt. Homoeo Dispensary", place: "Irinave, Kalliassery", type: "Homeopathy", phone: "9496361707", time: "9:00 AM - 2:00 PM", map: "#" },
    { id: 17, name: "Govt. Homoeo Dispensary", place: "Cherukunnu", type: "Homeopathy", phone: "8921532063", time: "9:00 AM - 2:00 PM", map: "#" },
    { id: 18, name: "Govt. Homoeo Dispensary", place: "Eriam, Kadannappally", type: "Homeopathy", phone: "9895059672", time: "9:00 AM - 2:00 PM", map: "#" },
    { id: 19, name: "Govt. Homoeo Dispensary", place: "Sreestha, Cheruthazham", type: "Homeopathy", phone: "6282169200", time: "9:00 AM - 2:00 PM", map: "#" },
    { id: 20, name: "Govt. Homoeo Dispensary", place: "Ettammal, Madayi", type: "Homeopathy", phone: "9847274111", time: "9:00 AM - 2:00 PM", map: "#" }
  ];

  const filteredHospitals = hospitalsData.filter((hospital) => {
    const matchSearch = hospital.name.toLowerCase().includes(search.toLowerCase()) || 
                        hospital.place.toLowerCase().includes(search.toLowerCase());
    const matchType = typeFilter === "All" || hospital.type === typeFilter;
    
    return matchSearch && matchType;
  });

  // 🔥 Page Share Functionality 🔥
  const handlePageShare = async () => {
    const shareData = {
      title: "Govt. Hospitals in Kalliasseri | Info Payangadi",
      text: "കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ സർക്കാർ ആശുപത്രികൾ, PHC, ആയുർവേദ, ഹോമിയോ ആശുപത്രികളുടെ പൂർണ്ണ വിവരങ്ങൾ ഒറ്റ ക്ലിക്കിൽ അറിയാൻ ഈ ലിങ്ക് സന്ദർശിക്കുക.",
      url: "https://info.payangadilive.com/hospitals" 
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.error("Error sharing:", err);
      }
    } else {
      navigator.clipboard.writeText(shareData.url);
      toast.success("ലിങ്ക് കോപ്പി ചെയ്തിട്ടുണ്ട്! (Link Copied)");
    }
  };

  return (
    <>
      {/* 🔥 Full SEO Tags 🔥 */}
      <Helmet>
        <title>Govt. Hospitals | Info Payangadi</title>
        <meta name="description" content="കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ സർക്കാർ ആശുപത്രികൾ, PHC, ആയുർവേദ, ഹോമിയോ ആശുപത്രികളുടെ പൂർണ്ണ വിവരങ്ങൾ." />
        <meta name="keywords" content="Hospitals Payangadi, Kalliasseri Govt Hospital, PHC Kannur, Ayurveda, Homeopathy, Info Payangadi" />
        
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://info.payangadilive.com/hospitals" />
        <meta property="og:title" content="Govt. Hospitals | Info Payangadi" />
        <meta property="og:description" content="കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ സർക്കാർ ആശുപത്രികൾ, PHC, ആയുർവേദ, ഹോമിയോ ആശുപത്രികളുടെ പൂർണ്ണ വിവരങ്ങൾ ഒറ്റ ക്ലിക്കിൽ." />
        <meta property="og:image" content="https://info.payangadilive.com/Infopayangadi.jpg" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Govt. Hospitals | Info Payangadi" />
        <meta name="twitter:description" content="കല്യാശ്ശേരി നിയോജക മണ്ഡലത്തിലെ സർക്കാർ ആശുപത്രികളുടെ ഡയറക്ടറി." />
        <meta name="twitter:image" content="https://info.payangadilive.com/Infopayangadi.jpg" />
      </Helmet>

      <div className="min-h-[100dvh] bg-[#F8FAFC] pb-24 selection:bg-blue-200 overflow-x-hidden relative">
        
        {/* Background Glows */}
        <div className="absolute top-[-10%] left-[-10%] w-[350px] h-[350px] bg-green-400/15 rounded-full blur-[100px] pointer-events-none"></div>
        <div className="absolute top-[20%] right-[-10%] w-[350px] h-[350px] bg-blue-400/10 rounded-full blur-[100px] pointer-events-none"></div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-8 md:pt-12 relative z-10">
          
          {/* TITLE SECTION WITH SHARE BUTTON */}
          <div className="text-center mb-10 px-2 flex flex-col items-center">
            <div className="inline-flex items-center justify-center p-3.5 bg-white text-green-600 rounded-2xl mb-3 shadow-[0_8px_30px_rgb(34,197,94,0.12)] border border-green-50">
              <PlusSquare size={32} strokeWidth={2.5} />
            </div>
            <h2 className="text-3xl sm:text-4xl font-black text-slate-800 tracking-tight">
              Govt. <span className="text-green-600">Hospitals</span>
            </h2>
            <p className="text-sm sm:text-base text-slate-500 mt-1 font-medium">കല്യാശ്ശേരി മണ്ഡലത്തിലെ സർക്കാർ ആരോഗ്യ കേന്ദ്രങ്ങൾ</p>

            {/* Page Share Button */}
            <motion.button
              whileTap={{ scale: 0.95 }}
              onClick={handlePageShare}
              className="mt-4 flex items-center gap-2 bg-white hover:bg-green-50 text-slate-600 hover:text-green-600 px-5 py-2.5 rounded-full shadow-sm border border-slate-200 transition-all duration-200 font-bold text-sm"
            >
              <Share2 size={16} strokeWidth={2.5} />
              Share Page
            </motion.button>
          </div>

          {/* 🔍 SEARCH + FILTER SECTION */}
          <div className="max-w-3xl mx-auto mb-10 flex flex-col md:flex-row gap-3 sm:gap-4 px-1">
            
            {/* Search Bar */}
            <div className="relative flex-1 group">
              <Search size={20} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-green-500 transition-colors" strokeWidth={2.5} />
              <input
                type="text"
                placeholder="ആശുപത്രിയോ സ്ഥലമോ തിരയുക..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full pl-11 pr-4 py-3.5 rounded-2xl border border-slate-200 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.03)] focus:ring-4 focus:ring-green-500/10 focus:border-green-400 outline-none transition-all text-sm font-semibold text-slate-800 placeholder:text-slate-400"
              />
            </div>

            {/* Filter Dropdown */}
            <div className="relative w-full md:w-56 group">
              <select
                value={typeFilter}
                onChange={(e) => setTypeFilter(e.target.value)}
                className="w-full appearance-none py-3.5 pl-4 pr-10 rounded-2xl border border-slate-200 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.03)] focus:ring-4 focus:ring-green-500/10 focus:border-green-400 outline-none transition-all text-sm font-bold text-slate-700 cursor-pointer"
              >
                <option value="All">All Hospitals</option>
                <option value="Allopathy">Allopathy (PHC/FHC)</option>
                <option value="Ayurveda">Ayurveda</option>
                <option value="Homeopathy">Homeopathy</option>
              </select>
              <ChevronDown size={18} strokeWidth={2.5} className="absolute right-4 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-green-500 pointer-events-none transition-colors" />
            </div>

          </div>

          {/* 🏥 HOSPITALS LIST */}
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="grid md:grid-cols-2 gap-4 sm:gap-6"
          >
            <AnimatePresence>
              {filteredHospitals.map((hospital) => (
                <motion.div
                  key={hospital.id}
                  variants={itemVariants}
                  layout
                  className="bg-white rounded-[2rem] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100 hover:shadow-[0_15px_40px_rgb(34,197,94,0.08)] transition-all duration-300 relative overflow-hidden group"
                >
                  {/* Type Badge */}
                  <div className="absolute top-5 right-5">
                    <span className={`px-3 py-1.5 rounded-full text-[10px] sm:text-xs font-black tracking-widest shadow-sm uppercase
                      ${hospital.type === "Allopathy" ? "bg-green-50 text-green-600 border border-green-100" : 
                        hospital.type === "Ayurveda" ? "bg-teal-50 text-teal-600 border border-teal-100" : 
                        "bg-blue-50 text-blue-600 border border-blue-100"}`}
                    >
                      {hospital.type}
                    </span>
                  </div>

                  {/* Info */}
                  <div className="pr-20 sm:pr-24">
                    <h3 className="text-lg sm:text-xl font-black text-slate-800 leading-tight mb-3 tracking-tight">
                      {hospital.name}
                    </h3>
                    
                    <div className="space-y-2 mt-2">
                      <div className="flex items-start gap-2.5 text-slate-500">
                        <div className="bg-red-50 p-1.5 rounded-lg flex-shrink-0">
                          <MapPin size={16} className="text-red-500" strokeWidth={2.5} />
                        </div>
                        <span className="text-xs sm:text-sm font-semibold mt-0.5">{hospital.place}</span>
                      </div>
                      
                      <div className="flex items-center gap-2.5 text-slate-500">
                        <div className="bg-orange-50 p-1.5 rounded-lg flex-shrink-0">
                          <Clock size={16} className="text-orange-500" strokeWidth={2.5} />
                        </div>
                        <span className="text-xs sm:text-sm font-bold mt-0.5">{hospital.time}</span>
                      </div>

                      {hospital.phone !== "Not Available" && (
                        <div className="flex items-center gap-2.5 text-slate-500">
                          <div className="bg-blue-50 p-1.5 rounded-lg flex-shrink-0">
                            <Phone size={16} className="text-blue-500" strokeWidth={2.5} />
                          </div>
                          <span className="text-xs sm:text-sm font-bold mt-0.5">{hospital.phone}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Action Buttons (Card) */}
                  <div className="mt-6 flex items-center gap-3 pt-5 border-t border-slate-100">
                    
                    <a 
                      href={hospital.phone !== "Not Available" ? `tel:${hospital.phone}` : "#"} 
                      onClick={(e) => {
                        if (hospital.phone === "Not Available") {
                          e.preventDefault();
                          toast.error("Phone number not available");
                        }
                      }}
                      className={`flex-1 flex items-center justify-center gap-1.5 sm:gap-2 py-3 rounded-xl transition-all duration-200 font-bold text-xs sm:text-sm ${
                        hospital.phone !== "Not Available" 
                          ? "bg-green-50 hover:bg-green-600 text-green-700 hover:text-white" 
                          : "bg-slate-50 text-slate-400 cursor-not-allowed"
                      }`}
                    >
                      <Phone size={16} strokeWidth={2.5} />
                      Call
                    </a>
                    
                    <a 
                      href={hospital.map} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="flex-1 flex items-center justify-center gap-1.5 sm:gap-2 bg-blue-50 hover:bg-blue-600 text-blue-600 hover:text-white py-3 rounded-xl transition-all duration-200 font-bold text-xs sm:text-sm"
                    >
                      <Navigation size={16} strokeWidth={2.5} />
                      Map
                    </a>

                  </div>
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>

          {/* No Results Found */}
          {filteredHospitals.length === 0 && (
            <motion.div 
              initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}
              className="text-center py-16 bg-white rounded-[2.5rem] border border-dashed border-slate-200 mt-4"
            >
              <div className="inline-flex items-center justify-center p-4 bg-slate-50 rounded-2xl mb-4">
                <Search size={32} className="text-slate-300" strokeWidth={2.5} />
              </div>
              <h3 className="text-lg sm:text-xl font-black text-slate-700 tracking-tight">No Hospitals Found</h3>
              <p className="text-slate-400 mt-1 text-sm font-medium">നിങ്ങൾ തിരഞ്ഞ വിവരങ്ങൾ കണ്ടെത്താനായില്ല.</p>
            </motion.div>
          )}

        </div>
      </div>
    </>
  );
}